import secureLocalStorage from "react-secure-storage";

// Function to set a string value
export const setStringValue = (key, value) => {
  if (key && value !== undefined) {
    secureLocalStorage.setItem(key, value);
  }
  return value;
};

// Function to get a string value
export const getStringValue = (key) => {
  if (key) {
    const value = secureLocalStorage.getItem(key);
    return value !== null ? value : null;
  }
  return null;
};

// Function to set an object value
export const setObjectValue = (key, data) => {
  if (key && data !== undefined) {
    try {
      secureLocalStorage.setItem(key, JSON.stringify(data)); // Serialize the object
    } catch (error) {
      console.error("Error storing object:", error);
    }
  }
  return data;
};

// Function to get an object value
export const getObjectValue = (key) => {
  if (key) {
    const value = secureLocalStorage.getItem(key);

    try {
      return value !== null ? JSON.parse(value) : null; // Parse the object
    } catch (error) {
      console.error("Error parsing object:", error);
    }
  }
  return null;
};

// Function to clear the storage
export const clearStorage = () => {
  secureLocalStorage.clear(); // Clear secure storage
};
